import { useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import SelectDevice from "./SelectDevice";
import { layout as statement } from "./ModelStatement";
import funcs from "tools/functions";
import PanelRight from "componentsv2/panel/PanelRight";
import Wizards from "./Wizards";
import { useLayout } from "hooks/layout";

function Statement() {
  const layout = useLayout(statement);
  const terminal = funcs.getCookie();
  const reloadBoard = useSignal(0);
  const currentView = useSignal("list");

  return (
    <div id="account-statement" className="flex md:flex-row flex-col w-full">
      <Board
        key={layout}
        layout={layout}
        style="md:w-5/6"
        reload={reloadBoard.value}
        currentView={currentView}
      />
      {!terminal.device_id && <SelectDevice />}
      <PanelRight title="Asistentes">
        <Wizards />
      </PanelRight>
    </div>
  );
}

export default Statement;
